import React from 'react';
import dayjs from 'dayjs';
import { Badge, Text } from '@mantine/core';
import { useNavigate } from 'react-router';
import { PRODUCT_LABELS } from '@/pages/Availability.page/constants';
import { AvailabilitySummary } from '../types';
import EventItemContainer from '../EventItem/EventItemContainer';
import { Page, ROUTES } from '@/constants';

type TodoItemAvailabilityProps = {
  summary: AvailabilitySummary;
};

const TodoItemAvailability: React.FC<TodoItemAvailabilityProps> = ({ summary }) => {
  const navigate = useNavigate();
  const dueDate = dayjs(summary.expiresAt).format('MMMM D');
  const isSingle = summary.restaurants.length === 1;
  const productLabel = PRODUCT_LABELS[summary.productType];

  const title = isSingle
    ? `Availability required for ${summary.restaurants[0].internalName} (${productLabel})`
    : `Availability required for ${summary.restaurants.length} ${productLabel} restaurants`;

  return (
    <EventItemContainer
      id={`availability-${summary.productType}`}
      onClick={() => navigate(ROUTES[Page.Availability])}
      cta="Review & submit"
    >
      <Text fw="bold" size="sm">
        {title}
      </Text>
      <Text size="sm" c="dimmed">
        Due date: {dueDate}
      </Text>
      {!isSingle && (
        <Text size="xs" c="dimmed" mt={4}>
          {summary.restaurants.map((r) => r.internalName).join(', ')}
        </Text>
      )}
      <Badge size="sm" p="xs" color="yellow" radius="md" variant="light" mt="xs">
        Action Required
      </Badge>
    </EventItemContainer>
  );
};

export default TodoItemAvailability;
